import { useMemo } from 'react'
import { Inline, Text } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'
import { PhoneIcon } from '../PhoneIcon'
import { IconProps, PhoneContentIcon } from '../Icon'
import { WhatsAppIcon } from '../WhatsAppIcon'

interface PhoneContentIconTypes {
  [key: string]: {
    name: string
    icon: (props: IconProps) => PhoneContentIcon
  }
}

interface PhoneContentProps {
  iconType?: string
  link: string
  phoneNumber: string
  locale: string
}

const contacts: PhoneContentIconTypes = {
  whatsapp: {
    name: 'WhatsApp',
    icon: WhatsAppIcon
  },
  phone: {
    name: 'Telefone',
    icon: PhoneIcon
  }
}

const PhoneContent = ({
  iconType = 'phone',
  link,
  phoneNumber,
  locale
}: PhoneContentProps) => {
  const { name, icon: Icon } = useMemo(() => contacts[iconType], [iconType])

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <Inline space="bit" alignX="flex-start" alignY="center" wrap="wrap">
        <Icon width={22} />
        <Text color="n900" size="kilo" noMargin>
          {name}:
        </Text>
        <S.PhoneNumber>
          <Text color="p600" size="kilo" isBold noMargin>
            {phoneNumber}
          </Text>
        </S.PhoneNumber>
        <Text color="n600" size="kilo" noMargin>
          {locale}
        </Text>
      </Inline>
    </a>
  )
}

export default PhoneContent
